import { RadarChart } from './RadarChart.component';

export default RadarChart;
